import { render } from "./CommandPalette.vue?vue&type=template&id=6b3a274b&scoped=true&ts=true"
import script from "./CommandPalette.vue?vue&type=script&lang=ts"
export * from "./CommandPalette.vue?vue&type=script&lang=ts"

import "./CommandPalette.vue?vue&type=style&index=0&id=6b3a274b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3a274b"]])

export default __exports__